import React from 'react';

import Typography from 'components/ui/Typography';
import i18n from 'utils/i18n';

import css from './Toast.module.scss';

export type ToastType = 'info' | 'error' | 'warning' | 'success';

interface Props {
    type: ToastType;
    header?: string | React.ReactChild;
    message?: string | React.ReactChild;
}

const Toast: React.FC<Props> = ({ type, header, message }) => {
    const textColor = type === 'info' ? 'gray' : 'white';
    const customHeader =
        type === 'success'
            ? i18n.t('Toast.Success')
            : type === 'warning'
              ? i18n.t('Toast.Warning')
              : type === 'error'
                ? i18n.t('Toast.Error')
                : header;

    return (
        <div className={css.toastContentWrapper}>
            <Typography ellipsis tag="div" color={textColor} style="BodyMedSemibold" className={css.headerEllipsis}>
                {customHeader}
            </Typography>
            <Typography tag="div" color={textColor}>
                {message}
            </Typography>
        </div>
    );
};

export default Toast;
